@if (logos().length) {
    <section class="logo-carousel">
        @if (heading()) {
            <p class="logo-carousel-heading">{{ heading() }}</p>
        }
        <div class="logo-carousel-viewport">
            <div class="logo-carousel-track" [style.--logo-carousel-shift]="trackShift">
                <div class="logo-carousel-set">
                    @for (logo of logos(); track $index) {
                        <ng-container *ngTemplateOutlet="logoTemplate; context: { logo, alt: logo.alt }" />
                    }
                </div>
                @for (copy of duplicateSets; track copy) {
                    <div class="logo-carousel-set" aria-hidden="true">
                        @for (logo of logos(); track $index) {
                            <ng-container *ngTemplateOutlet="logoTemplate; context: { logo, alt: '' }" />
                        }
                    </div>
                }
            </div>
        </div>
    </section>
}

<ng-template #logoTemplate let-logo="logo" let-alt="alt">
    @if (logo.imageData; as imageData) {
        <sirius-image-item
            class="logo-carousel-logo"
            [style.width.px]="logo.width"
            [style.height.px]="logo.height"
            [image]="logo.image"
            [imageData]="imageData"
            [alt]="alt"
            [autocrop]="false" />
    } @else {
        <img
            class="logo-carousel-logo"
            [style.max-height.px]="maxLogoHeight"
            [src]="logo.image.image.url"
            [alt]="alt" />
    }
</ng-template>
